import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 24a24 24 0 1 1 48 0 24 24 0 0 1-48 0Zm24-12.8c-3.48 0-3.91.02-5.28.08a9.4 9.4 0 0 0-3.1.6c-.85.32-1.56.76-2.27 1.47a6.28 6.28 0 0 0-1.48 2.27 9.35 9.35 0 0 0-.6 3.1c-.05 1.37-.07 1.8-.07 5.28 0 3.48.02 3.91.08 5.28a9.4 9.4 0 0 0 .6 3.1c.32.85.76 1.56 1.47 2.27a6.27 6.27 0 0 0 2.27 1.48 9.4 9.4 0 0 0 3.1.6c1.37.06 1.8.07 5.28.07 3.48 0 3.91-.01 5.28-.08a9.4 9.4 0 0 0 3.1-.6 6.26 6.26 0 0 0 2.27-1.47 6.28 6.28 0 0 0 1.48-2.27 9.7 9.7 0 0 0 .6-3.1c.05-1.37.07-1.8.07-5.28 0-3.48-.02-3.91-.08-5.28a9.48 9.48 0 0 0-.6-3.1 6.28 6.28 0 0 0-1.47-2.27 6.26 6.26 0 0 0-2.27-1.48 9.42 9.42 0 0 0-3.1-.6c-1.37-.05-1.8-.07-5.28-.07Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M22.85 13.5H24c3.42 0 3.82.02 5.17.08 1.25.06 1.93.27 2.38.44.6.23 1.02.51 1.47.96.45.45.73.87.96 1.47.17.45.38 1.13.44 2.38.06 1.35.07 1.75.07 5.17 0 3.41 0 3.82-.07 5.17a7.08 7.08 0 0 1-.44 2.37c-.23.6-.51 1.03-.96 1.47-.45.45-.87.73-1.47.96a6.8 6.8 0 0 1-2.38.44c-1.35.06-1.75.08-5.17.08a89.1 89.1 0 0 1-5.17-.08 7.1 7.1 0 0 1-2.38-.44 3.8 3.8 0 0 1-1.47-.96 3.97 3.97 0 0 1-.96-1.47 7.07 7.07 0 0 1-.44-2.37 89.42 89.42 0 0 1-.07-5.18c0-3.41.01-3.82.07-5.17a7.3 7.3 0 0 1 .44-2.37c.23-.6.51-1.03.96-1.48a4 4 0 0 1 1.47-.95 7.07 7.07 0 0 1 2.38-.44c1.18-.06 1.64-.07 4.02-.08Zm7.98 2.13a1.54 1.54 0 1 0 0 3.07 1.54 1.54 0 0 0 0-3.07ZM24 17.43a6.57 6.57 0 1 0 0 13.14 6.57 6.57 0 0 0 0-13.14Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24 19.73a4.27 4.27 0 1 1 0 8.54 4.27 4.27 0 0 1 0-8.54Z",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render: render }